module.exports = __webpack_public_path__ + "img/Ellipse-bg.d9c3574a.svg";